import React from 'react';

// أضف هذه التنسيقات في ملف CSS عام أو استخدمها كمكونات منمقة (styled-components)
// للسهولة، سنضعها هنا مباشرة باستخدام كائن style
const styles: { [key: string]: React.CSSProperties } = {
  spinnerOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  spinner: {
    border: '8px solid #f3f3f3', // رمادي فاتح
    borderTop: '8px solid #1890ff', // أزرق
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    animation: 'spin 1s linear infinite',
  },
};

// تعريف keyframes للأنيميشن. يجب إضافتها في ملف CSS
// سنضيفها عبر وسم <style> في المكون نفسه كحل سريع
const keyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

interface LoadingSpinnerProps {
  fullScreen?: boolean; // لتحديد ما إذا كان يغطي الشاشة كاملة
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ fullScreen = false }) => {
  const spinnerElement = (
    <>
      <style>{keyframes}</style>
      <div style={styles.spinner}></div>
    </>
  );

  if (fullScreen) {
    return (
      <div style={styles.spinnerOverlay}>
        {spinnerElement}
      </div>
    );
  }

  return spinnerElement;
};

export default LoadingSpinner;
